var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('history-item-template',{attrs:{"createTime":_vm.action.createTime,"creatorName":_vm.action.creatorName,"comment":_vm.action.data.comment,"vbAttachments":_vm.action.attachments},on:{"downloadFile":function (ref) {
	var vbAttachment = ref.vbAttachment;

	return _vm.$emit('downloadFile', {vbAttachment: vbAttachment});
}},scopedSlots:_vm._u([{key:"historyHeader",fn:function(){return [_c('p',{class:['action-type flex-row flex__left inline-flex', 'color__green']},[_c('i',{class:['font-size__small', 'fal fa-edit']}),_vm._v(" "),_c('span',{staticClass:"font-size__small no_wrap"},[_vm._v("  "+_vm._s("Cho ý kiến")+" ")])])]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330beafe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-in/doc-in-cho-y-kien-history-item.vue
// module id = GQ8c
// module chunks = 89